import { nativeApplicationVersion, nativeBuildVersion } from "@-/com.npmjs.expo-application";

// `0.0.0 (108)`: the native binary's semver (CFBundleShortVersionString / Android
// versionName) plus its build number (CFBundleVersion / Android versionCode) in parens.
// Read from the native binary via expo-application — the build number isn't carried in
// the JS-side Expo config. Both are null on web (no native binary), so fall back to just
// the semver, then to "—" when neither is available.
//
// Shared by the About settings section row (which shows it on the right of the "About"
// row) and the About settings page (which shows it again inside the page).
export function getAppVersionLabel(): string {
  if (nativeApplicationVersion == null) {
    return "—";
  }

  return nativeBuildVersion == null
    ? nativeApplicationVersion
    : `${nativeApplicationVersion} (${nativeBuildVersion})`;
}
